
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "i18n!conversations.submission_comment_form_dialog";
import "coffeescripts/handlebars_helpers.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = 'conversations/SubmissionCommentFormDialog';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, functionType="function", escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing;


  buffer += "<form class=\"reply_form\" method=\"post\"\n  action=\"/api/v1/courses/"
    + escapeExpression(((stack1 = ((stack1 = ((stack1 = (depth0 && depth0.conversation)),stack1 == null || stack1 === false ? stack1 : stack1.assignment)),stack1 == null || stack1 === false ? stack1 : stack1.course_id)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "/assignments/"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.conversation)),stack1 == null || stack1 === false ? stack1 : stack1.assignment_id)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "/submissions/"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.conversation)),stack1 == null || stack1 === false ? stack1 : stack1.user_id)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\" class=\"form-horizontal\"\n  >\n\n  <input type=\"hidden\" name=\"_method\" value=\"put\">\n\n  <div class='message-body'>\n    <textarea name=\"comment[text_comment]\"\n              data-track-category=\"Compose Message\"\n              data-track-action=\"Edit\"\n              data-track-label=\"Body\"\n              aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("conversations.submission_comment_form_dialog")
  },data:data},helper ? helper.call(depth0, "body", "Body", options) : helperMissing.call(depth0, "t", "body", "Body", options)))
    + "\"\n              class=\"reply_body\"></textarea>\n    <div class='context_messages'></div>\n  </div>\n</form>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  